import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import GiveBadgeIcon from '@wix/da-ds/pkg/Icons/24x24/GiveBadge';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarButton from '../../_partials/items/ActionBarButton';
import ActionBarButtonRestricted from '../../_partials/ActionBarButtonRestricted';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import { AwardBadgeSource } from '../../../coreBadge/types';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import { BiData, GiveBadgeAwardBiEvent } from '@wix/da-bi/pkg/events';

export interface Props {
  deviation: PapiDeviation;
  limitedBadgesPromo?: any;
  onAwardClick: (deviation: PapiDeviation, source: AwardBadgeSource) => void;
}

const AwardBadgeButton: React.FC<Props> = ({ deviation, limitedBadgesPromo, onAwardClick }) => {
  const { t } = useTranslation();
  const { restrictToLoggedIn } = useRestrictToLoggedIn();

  const typeId = getDeviationResourceType(deviation);
  const clickHandler = useCallback(() => {
    yieldToMain(() => {
      onAwardClick(deviation, AwardBadgeSource.ACTIONBAR_BUTTON);
    });
  }, [onAwardClick, deviation]);

  const tooltip = t('actionbar.awardBadge');
  return (
    <ActionBarButtonRestricted
      subscribersOnly
      deviation={deviation}
      tooltip={tooltip}
      button={
        <ActionBarButton
          onClick={restrictToLoggedIn(ReferralType.AWARD_BADGE, clickHandler)}
          aria-label={tooltip}
          biData={BiData<GiveBadgeAwardBiEvent>({
            evid: 320,
            sectionname: 'deviation',
            typeid: typeId,
            itemid: deviation.deviationId,
          })}
        >
          {limitedBadgesPromo?.campaignIconOverride ? (
            <img
              src={limitedBadgesPromo.campaignIconOverride}
              width="24"
              height="24"
              alt=""
              loading="lazy"
            />
          ) : (
            <ActionBarIcon icon={GiveBadgeIcon} />
          )}
        </ActionBarButton>
      }
    />
  );
};
AwardBadgeButton.displayName = 'AwardBadgeButton';

export default AwardBadgeButton;
